export const GetFolderListConst="GetFolderList"
export const GetFileListConst="GetFileList"
export const FolderStackConst="FolderStack"
export const GetFolderAndFilesByParentlistConst="GetFolderAndFilesByParentlist"